import { color } from '@repay/cactus-theme';
import PropTypes from 'prop-types';
var statuses = ['success', 'warning', 'error'];
export var StatusPropType = PropTypes.oneOf(statuses);
export var getStatusStyles = function getStatusStyles(p) {
  if (!p.disabled && statuses.includes(p.status)) {
    return {
      borderColor: color(p, p.status),
      backgroundColor: color(p, "".concat(p.status, "Light"))
    };
  }
};